module.exports = __webpack_public_path__ + "static/media/subwayLogo.e6bcfc3c.png";